import { render, staticRenderFns } from "./ProductionPackageDialog.vue?vue&type=template&id=5416961f&scoped=true"
import script from "./ProductionPackageDialog.vue?vue&type=script&lang=js"
export * from "./ProductionPackageDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductionPackageDialog.vue?vue&type=style&index=0&id=5416961f&prod&lang=css"
import style1 from "./ProductionPackageDialog.vue?vue&type=style&index=1&id=5416961f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416961f",
  null
  
)

export default component.exports